import SolicitacaoFaturamento from './componentes/SolicitacaoFaturamento.vue';
import SolicitacaoFaturamentoLista from './componentes/SolicitacaoFaturamentoLista.vue';
import SolicitacaoFaturamentoForm from './componentes/SolicitacaoFaturamentoForm.vue';
import SolicitacaoFaturamentoRelatorio from './componentes/SolicitacaoFaturamentoRelatorio.vue';

export default {
  path: '/solicitacao-faturamento-estrangeiro-pf',
  component: SolicitacaoFaturamento,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoFaturamentoLista,
      name: 'solicitacao-faturamento-estrangeiro-pf',
    },
    {
      path: 'nova',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-estrangeiro-pf.nova'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoFaturamentoRelatorio,
      name: 'solicitacao-faturamento-estrangeiro-pf.relatorio'
    },
    {
      path: ':id',
      component: SolicitacaoFaturamentoForm,
      name: 'solicitacao-faturamento-estrangeiro-pf.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pf/rotas.js